import { ReactNode } from 'react';

import { Text, TextProps } from '@/design-system';

export const FormSection = ({
  title,
  description,
  children,
  topRightElement,
  titleVariant,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  topRightElement?: ReactNode;
  titleVariant?: TextProps['variant'];
}) => {
  const titleComponent = (
    <Text variant={titleVariant || 'body'} weight="medium">
      {title}
    </Text>
  );

  return (
    <div className="flex flex-col gap-1">
      {topRightElement ? (
        <div className="flex items-center justify-between">
          {titleComponent}
          {topRightElement}
        </div>
      ) : (
        titleComponent
      )}
      {description && (
        <Text variant="body" className="text-quaternary">
          {description}
        </Text>
      )}
      <div className="mt-1 flex flex-col gap-3">{children}</div>
    </div>
  );
};

export const ErrorText = ({ error }: { error?: string }) => {
  if (!error) {
    return null;
  }
  return (
    <Text variant="sm" className="text-error">
      {error}
    </Text>
  );
};
